"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ProposalTypeNil = 0x00;
var ProposalTypeText = 0x01;
var ProposalTypeParameterChange = 0x02;
var ProposalTypeSoftwareUpgrade = 0x03;
var ProposalTypeListTradingPair = 0x04;
var ProposalTypeFeeChange = 0x05;
var ProposalTypeCreateValidator = 0x06;
var ProposalTypeRemoveValidator = 0x07;
var _default = {
  ProposalTypeNil: ProposalTypeNil,
  ProposalTypeText: ProposalTypeText,
  ProposalTypeParameterChange: ProposalTypeParameterChange,
  ProposalTypeSoftwareUpgrade: ProposalTypeSoftwareUpgrade,
  ProposalTypeListTradingPair: ProposalTypeListTradingPair,
  ProposalTypeFeeChange: ProposalTypeFeeChange,
  ProposalTypeCreateValidator: ProposalTypeCreateValidator,
  ProposalTypeRemoveValidator: ProposalTypeRemoveValidator
};
exports["default"] = _default;